import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {Sound} from '../../../../shared/scripts/Sound'
import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIManager} from '../UIManager'
import {Scene} from '../UISceneTypes'
import {MatchmakingCardCategory} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorController'
import {UIWHeaderController} from '../header/UIWHeaderController'

export class UILandingPageController {
    protected readonly uiManager: UIManager
    protected readonly header: UIWHeaderController
    private readonly landingPageContainerDiv: HTMLDivElement
    readonly playWithFriendsCTA: HTMLLinkElement
    private readonly playOnlineCTA: HTMLLinkElement

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager

        this.header = new UIWHeaderController()
        this.landingPageContainerDiv = document.getElementById('scene_landing_page_container') as HTMLDivElement
        this.playWithFriendsCTA = document.getElementById('landingpage_cta_playwithfriends') as HTMLLinkElement
        this.playOnlineCTA = document.getElementById('landingpage_cta_playonline') as HTMLLinkElement

        setElementOnClick(this.playWithFriendsCTA, () => this.clickPlayWithFriendsCTA())
        setElementOnClick(this.playOnlineCTA, () => this.clickPlayOnlineCTA())
    }

    private clickPlayWithFriendsCTA() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPagePlayWithFriends)
        this.uiManager.sceneController.loadScene(Scene.Lobby)
    }

    private clickPlayOnlineCTA() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageExploreModes)
        this.uiManager.modeSelector.selectTab(MatchmakingCardCategory.Bots)
        this.uiManager.sceneController.loadScene(Scene.MainPage)
    }

    hide() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'none'
    }

    show() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'flex'
    }
}
